import { EventParticipationsRepository } from '@lib/api/repository/event-participations/event-participations.repository';
import { EventParticipationsUseCase } from '@lib/interfaces/usecase/event-participations.use-case';
import {
  ChangeParticipationInput,
  EventParticipation,
  ParticipationFilters,
  ParticipationView,
} from '@lib/types/event-participation';

export default class EventParticipationsService implements EventParticipationsUseCase {
  constructor(private repository: EventParticipationsRepository) {}
  list(
    eventId: string,
    view: ParticipationView,
    filters: ParticipationFilters,
    signal?: AbortSignal,
  ) {
    return this.repository.list(eventId, view, filters, signal);
  }

  confirmed(eventId: string, signal?: AbortSignal): Promise<EventParticipation[]> {
    return this.participationPages(eventId, 'public', 1, signal);
  }

  owned(eventId: string, signal?: AbortSignal): Promise<EventParticipation[]> {
    return this.participationPages(eventId, 'mine', 1, signal);
  }

  private async participationPages(
    eventId: string,
    view: 'public' | 'mine',
    page: number,
    signal?: AbortSignal,
  ): Promise<EventParticipation[]> {
    const result = await this.repository.list(
      eventId, view, { page, limit: 50 }, signal,
    );

    if (!result.items.length || page * result.limit >= result.total) {
      return result.items;
    }

    const remaining = await this.participationPages(eventId, view, page + 1, signal);
    return [...result.items, ...remaining];
  }

  stores(search: string, page: number, admin: boolean, signal?: AbortSignal) {
    return this.repository.stores(search, page, admin, signal);
  }

  change(input: ChangeParticipationInput) {
    return this.repository.change(input);
  }
}
